import React from 'react'
import ReactDOM from "react-dom/client"
//@ts-ignore
import fslightbox from 'fslightbox'
import gsap from 'gsap'
import Flip from 'gsap/Flip'
import ScrollTrigger from "gsap/ScrollTrigger"
import Flickity from 'flickity'
import {HeroRight} from './hero-right'
import {SideDrawer} from './drawer'
import r2wc from "react-to-webcomponent"
import 'flickity/dist/flickity.min.css'
import '../scss/index.scss'
import '../scss/_root.scss'
import '../scss/_content.scss'
import '../scss/_contact.scss'
import '../scss/_header.scss'
import '../scss/tailwind.css'

gsap.registerPlugin(ScrollTrigger)
window.gsap = gsap
window.Flip = Flip
window.fslightbox = fslightbox
window.ScrollTrigger = ScrollTrigger
window.Flickity = Flickity

customElements.define("hero-right", r2wc(HeroRight, React, ReactDOM, {
  props: {
    logged: "boolean",
    step: "number",
    makerstring: "string",
    categorystring: "string"
  }
}))

customElements.define('side-drawer', r2wc(SideDrawer, React, ReactDOM))

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.faq-item').forEach(faq_item => {
    faq_item.addEventListener('click', () => {
      faq_item.classList.toggle('collapsed')
    })
  })
})


